var _metadata, _defs, _g, _mask, _g2, _mask2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.55697592917784 55.41255089082466",
    width: 46.55697592917784,
    height: 55.41255089082466,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.86800981549982 10) rotate(0 -12.914023483808649 8.899479724934594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.3 2.97, -21.52 14.83, -25.83 17.8 M0 0 C-4.3 2.97, -21.52 14.83, -25.83 17.8",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 28.082172102648713) rotate(0 13.27848796458892 8.665189394087975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.43 2.89, 22.13 14.44, 26.56 17.33 M0 0 C4.43 2.89, 22.13 14.44, 26.56 17.33",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.1ba3ae77d87cda4e014d507bc2561349.svg";
export { ForwardRef as ReactComponent };